import { forwardRef, type ComponentProps, type ReactNode } from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";
import { buttonVariants } from "../button/styles";
import { useRadioGroupButtonsContext } from "./radioGroupButtonsContext";

export interface RadioGroupButtonItemProps extends Omit<ComponentProps<typeof RadioGroupPrimitive.Item>, "children"> {
  children: ReactNode;
  size?: VariantProps<typeof buttonVariants>["size"];
}

export const RadioGroupButtonItem = forwardRef<HTMLButtonElement, RadioGroupButtonItemProps>(
  ({ className, children, value, size, ...props }, ref) => {
    const { value: groupValue, selectedVariant, unselectedVariant } = useRadioGroupButtonsContext();
    const isSelected = groupValue === value;
    const variant = isSelected ? selectedVariant : unselectedVariant;

    return (
      <RadioGroupPrimitive.Item
        ref={ref}
        data-slot="radio-group-button-item"
        value={value}
        className={cn(buttonVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </RadioGroupPrimitive.Item>
    );
  }
);
RadioGroupButtonItem.displayName = "RadioGroupButtonItem";
